import { RegionsHelpers } from '../../service/RegionsHelpers/RegionsHelpers';
import { Region } from '../../typings/common';
import { TopRegionQuery } from '../../typings/graphql-grid';
import { RegionsEditorQuickSelectItem } from '../../typings/regionsEditor';
import { Regions } from '../../typings/state';

export const mapQuickSelectedItemsForRegionsTransformEditor = (
    regionsResult: Regions,
    regionTree: Region[],
    topRegion: TopRegionQuery
): RegionsEditorQuickSelectItem[] => {
    return topRegion.adGroupTopRegions.regions.map(preset => {
        return {
            title: RegionsHelpers.getRegionsTexts(regionsResult, preset.regionIds, ','),
            selectedMap: RegionsHelpers.getSelectedMapFromRawRegionData(regionTree, preset.regionIds)
        };
    });
};
